import { combineReducers } from "redux";
import { intlReducer } from "react-intl-redux";
import users from "./users";
import userAvatars from "./userAvatars";
import api from "./api";
import loading from "./loading";
import cbook from "./cbook";
import nodes from "./nodes";
import currentSlide from "./currentSlide";
import contents from "./contents";
import completed from "./completed";
import originSlide from "./originSlide";
import quickFavOriginSlide from "./quickFavOriginSlide";
import claims from "./claims";
import uiVisibilityState from "./uiVisibilityState";
import storyMode from "./storyMode";
import bonusMaterial from "./bonusMaterial";
import keyValueStore from "./keyValueStore";
import favorites from "./favorites";
import searchableSlides from "./searchableSlides";
import search from "./search";
import ratings from "./ratings";
import debugMessages from "./debugMessages";
import lastVisitedSlide from "./lastVisitedSlide";
import errors from "./errors";
import student from "./student";
import notifications from "./notifications";
import session from "./session";
import groups from "./groups";
import socialConfig from "./socialConfig";
import exam from "./exam";
import examInteractions from "./examInteractions";
import examData from "./examData";
import completeable from "./completeable";
import activities from "./activities";
import topics from "./topics";
import socialChartData from "./socialChartData";
import notes from "./notes";
import connections from "./connections";
import alerts from "./alerts";
import communityChartData from "./communityChartData";
import media from "./media";
export default combineReducers({
    activities: activities,
    alerts: alerts,
    api: api,
    bonusMaterial: bonusMaterial,
    cbook: cbook,
    claims: claims,
    communityChartData: communityChartData,
    completeable: completeable,
    completed: completed,
    connections: connections,
    contents: contents,
    currentSlide: currentSlide,
    debugMessages: debugMessages,
    errors: errors,
    exam: exam,
    examData: examData,
    examInteractions: examInteractions,
    favorites: favorites,
    groups: groups,
    intl: intlReducer,
    keyValueStore: keyValueStore,
    lastVisitedSlide: lastVisitedSlide,
    loading: loading,
    media: media,
    nodes: nodes,
    notes: notes,
    notifications: notifications,
    originSlide: originSlide,
    quickFavOriginSlide: quickFavOriginSlide,
    ratings: ratings,
    search: search,
    searchableSlides: searchableSlides,
    session: session,
    socialConfig: socialConfig,
    storyMode: storyMode,
    student: student,
    topics: topics,
    uiVisibilityState: uiVisibilityState,
    users: users,
    userAvatars: userAvatars,
    socialChartData: socialChartData
});
